export const statusKeys = [
  'approved',
  'awaiting_assignment',
  'awaiting_provider_qc',
  'awaiting_qc',
  'awaiting_review',
  'changes_requested',
  'complete',
  'information_requested',
  'pending',
  'processing',
  'queued',
] as const

export type StatusKey = typeof statusKeys

export const statusSettings = {
  approved: {
    color: '#8c9fbf',
  },
  awaiting_assignment: {
    color: '#e78d2d',
  },
  awaiting_provider_qc: {
    color: '#e78d2d',
  },
  awaiting_qc: {
    color: '#e78d2d',
  },
  awaiting_review: {
    color: '#e78d2d',
  },
  changes_requested: {
    color: '#e78d2d',
  },
  complete: {
    color: '#43ac6a',
  },
  information_requested: {
    color: '#e78d2d',
  },
  pending: {
    color: '#e78d2d',
  },
  processing: {
    color: '#b69deb',
  },
  queued: {
    color: '#b69deb',
  },
}

// order is important
export const priorityKeys = [
  'default',
  'medium',
  'high',
] as const

export type PriorityKey = typeof priorityKeys

export const prioritySettings = {
  default: {
    color: '#c7c7c8',
    label: 'Default',
    weighting: 0,
  },
  high: {
    color: '#e2001a',
    label: 'High',
    weighting: 10,
  },
  medium: {
    color: '#e78d2d',
    label: 'Medium',
    weighting: 5,
  },
}

export const getColor = (type: 'status' | 'priority', key: StatusKey | PriorityKey) => {
  const settings = type === 'priority' ? prioritySettings : statusSettings
  const { color } = settings[key] || {}
  return color || 'black'
}

export const getPriorityWeighting = (key: PriorityKey) => {
  const { weighting } = prioritySettings[key] || {}
  return weighting || 0
}
